import { Drawer, Descriptions, Spin } from 'antd';
import type { DescriptionsProps } from 'antd';
import type { ReactNode } from 'react';

export interface EntityDrawerProps {
  open: boolean;
  onClose: () => void;
  title: string;
  loading?: boolean;
  items?: DescriptionsProps['items'];
  children?: ReactNode;
  extra?: ReactNode;
  width?: number;
}

function EntityDrawer({
  open,
  onClose,
  title,
  loading = false,
  items,
  children,
  extra,
  width = 560,
}: EntityDrawerProps) {
  return (
    <Drawer
      open={open}
      onClose={onClose}
      title={title}
      width={width}
      extra={extra}
      className="admin-entity-drawer"
      destroyOnClose
    >
      {loading ? (
        <div style={{ textAlign: 'center', padding: 48 }}>
          <Spin />
        </div>
      ) : children ? (
        children
      ) : (
        <Descriptions column={1} bordered size="small" items={items} />
      )}
    </Drawer>
  );
}

export default EntityDrawer;
